import { sumBy } from 'lodash-es'

export const CartCoupon = (json: ICartCoupon): ICartCouponModel => {
	const fromJSON = (cartCoupon: ICartCoupon) => {
		const { promotion, ...rest } = cartCoupon
		return {
			promotion: promotion ? DiscountPromotion(promotion) : null,
			...rest,
		}
	}

	return { ...fromJSON(json) }
}

export const CartDiet = (json: ICartDiet): ICartDietModel => {
	const fromJSON = (cartDiet: ICartDiet) => {
		const { address, days, delivery_price, diet_nickname, diet_id, ...rest } = cartDiet
		return {
			address: address ? ClientAddress(address) : undefined,
			days: days ? days.map(OrderDay) : [],
			deliveryPrice: delivery_price,
			dietNickname: diet_nickname,
			dietID: diet_id,
			...rest,
		}
	}
	return { ...fromJSON(json) }
}

export const CartItem = (json: ICartItem): ICartItemModel => {
	const fromJSON = (cartItem: ICartItem) => {
		const { original_price, cart_diet, ...rest } = cartItem
		return {
			originalPrice: original_price,
			cartDiet: cart_diet ? CartDiet(cart_diet) : null,
			...rest,
		}
	}

	return { ...fromJSON(json) }
}

/** `carts-to-pay` nie zwraca dostawy koszyka - sumujemy ją z dni diet. */
const sumCartDeliveryPrice = (items: ICartItemModel[]): number =>
	sumBy(items, item => sumBy(item.cartDiet?.days, day => day.deliveryPrice ?? 0))

export const Cart = (json: ICart): ICartModel => {
	const fromJSON = (cart: ICart) => {
		const {
			coupon,
			created_at,
			invoices,
			items,
			original_price,
			price,
			price_without_delivery,
			delivery_price,
			price_to_pay,
			wallet_top_up_amount_reserved,
			wallet_cashback_amount_reserved,
			wallet_promo_amount_reserved,
			receipts,
			...rest
		} = cart
		const cartItems = items ? items.map(item => CartItem(item)) : []
		const deliveryPrice = delivery_price ?? sumCartDeliveryPrice(cartItems)

		return {
			coupon: coupon ? CartCoupon(coupon) : null,
			createdAt: new Date(created_at),
			invoices: invoices ? invoices.map(invoice => Invoice(invoice)) : [],
			items: cartItems,
			originalPrice: original_price,
			price,
			priceWithoutDelivery: price_without_delivery ?? price - deliveryPrice,
			deliveryPrice,
			priceToPay: price_to_pay ?? price,
			walletTopUpAmountReserved: wallet_top_up_amount_reserved ?? 0,
			walletCashbackAmountReserved: wallet_cashback_amount_reserved ?? 0,
			walletPromoAmountReserved: wallet_promo_amount_reserved ?? 0,
			receipts: receipts ? receipts.map(receipt => Receipt(receipt)) : [],
			...rest,
		}
	}

	return { ...fromJSON(json) }
}
